export const SELECT_QUESTION_LIST = "SELECT_QUESTION_LIST";
export const CHANGE_QUESTION_LIST = "CHANGE_QUESTION_LIST";
export const REMOVE_ORDER_IMG = "REMOVE_ORDER_IMG";
export const SELECT_ORDER_ID = "SELECT_ORDER_ID";
export const SENDUS_HANDLE_TEXT_CHANGE = "SENDUS_HANDLE_TEXT_CHANGE";
export const GET_SENDUS_QUESITONS = "GET_SENDUS_QUESITONS";
export const SENDUS_IMG_HASH = "SENDUS_IMG_HASH";
export const SENDUS_RESET_FORM = "SENDUS_RESET_FORM";
export const SENDUS_SUBMITFORM_MODAL = "SENDUS_SUBMITFORM_MODAL";
